import { createFileRoute, redirect } from "@tanstack/react-router";

import { authUserSchema } from "@/modules/auth/schemes";
import { CustomerOngoingPage } from "@/modules/customers/pages/CustomerOngoing.page";

export const Route = createFileRoute("/__authed/m/customers/ongoing")({
	beforeLoad({ context }) {
		const user = "user" in context ? context.user : undefined;
		const parsedUser = authUserSchema.safeParse(user);

		if (!parsedUser.success || parsedUser.data.role.slug !== "store") {
			throw redirect({ to: "/m/dashboard" });
		}
	},
	component: RouteComponent,
});

function RouteComponent() {
	const context = Route.useRouteContext();
	const rawUser =
		context && typeof context === "object" && "user" in context ? context.user : undefined;
	const parsedUser = authUserSchema.safeParse(rawUser);
	const user = parsedUser.success ? parsedUser.data : undefined;

	return <CustomerOngoingPage clientId={user?.personId} />;
}
